export default {
  SET_USER(state, user) {
    state.user = user;

    if (user) {
      localStorage.setItem("usuario", JSON.stringify(user));
    } else {
      localStorage.removeItem("usuario");
    }
  },
  SET_TOKEN(state, token) {
    state.token = token;

    if (token) {
      localStorage.setItem("token", token);
    } else {
      localStorage.removeItem("token");
    }
  },
  SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions || [];

    if (permissions?.length) {
      localStorage.setItem("permissions", JSON.stringify(permissions));
    } else {
      localStorage.removeItem("permissions");
    }
  },
  LOGOUT(state) {
    state.user = null;
    state.token = null;
    state.permissions = [];

    localStorage.removeItem("usuario");
    localStorage.removeItem("token");
    localStorage.removeItem("permissions");
  },
};
